/**
 * Auth0 Configuration
 *
 * Configuration constants for Auth0 authentication.
 * Values are loaded from environment variables.
 * Uses localStorage caching for faster auth restoration on page load
 * and refresh tokens for longer sessions without re-authentication.
 */

export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  cacheLocation: "localstorage" as const,
  useRefreshTokens: true,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  },
};
